import * as IconSelector from '../icons';

export const unidadVencimientos = [
    {
        value: 'Dias',
        label: 'Dias',
        description: 'Días',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Meses',
        label: 'Meses',
        description: 'Meses',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    }
];
